"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.technicalPdfs = exports.certificatesPdfs = void 0;
const certificatesPdfs = ['2014 SEPT BENOR BREEDPLAAT', 'BENOR certificaat 2013 vloerelementen', 'benor_picasse-40x40', 'BENOR-PTV-102-Laakdal', 'benor_waterdoorlatende_betonstraatstenen_bleijko_roeselare_-_ptv_122_tem._2020-02-08', 'Documentatie280818110255', 'Documentatie281117161942'];
exports.certificatesPdfs = certificatesPdfs;
const technicalPdfs = ['3a_101_voorbeeld', '3b_106_voorbeeld1', '3b_106_voorbeeld2'];
exports.technicalPdfs = technicalPdfs;